<template>
  <div class="container">
    <div class="header">
        <div id="form-search-projects" class="card">
          <Search
            v-model="searchFraze"
            @search="onSearchUsers"
            @clearSearch="onClearSearch"
          />
        </div>
    </div>
    <user-permissions-table
      v-if="isReady"
      ref="table"
      :users="usersData"
      :updateRecord="updateRecord"
      :updatingRecord="updating"
      :onSort="onSort"
      :pagination="pagination"
      :loading="isBusy"
      @loadMore="onLoadMore"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Search from "@/components/Search.vue";
import UserPermissionsTable from '@/components/coding-user-permissions/user-permissions-table';

export default {
  mounted() {
    this.fetch();
  },

  data: function() {

    let filters = {};
    const { name } = this.$route.query;

    if (name) {
      filters.name = name;
    }

    return {
      isReady: false,
      filters,
      filtering: false,
      searchFraze: "",
      pagination: {
        page: 1,
        perPage: 20,
        order: 'email',
        sort: 'asc'
      },
    }
  },

  computed: {
    ...mapState({
      isBusy: state => state.userPermissions.isBusy,
      users: state => state.userPermissions,
      usersPagination: state => state.userPermissions.pagination,
      updating: state => state.userPermissions.updating
    }),
    usersData() { return this.users && this.users.data ? this.users.data : [] },
    hasMorePages() { return this.usersPagination && this.usersPagination.currentPage < this.usersPagination.totalPages }
  },

  methods: {
    fetch() {
      let { pagination, filters } = this;
      this.getUserPermissions({ pagination, filters })
      .then(() => {
        if(!this.isReady) this.isReady = true
      });
    },

    updateRecord(id, key, value) {
      const row = {
        user_id: id,
        [key]: value
      }
      this.updateUserPermissions({ row });
    },

    onSort(order, sort) {
      this.pagination.order = order;
      this.pagination.sort = sort;
      this.pagination.page = 1;
      this.fetch();
    },
    scroll() {
      if (this.usersPagination.currentPage < this.usersPagination.totalPages) {
        const wHeight = window.innerHeight;
        const {
          top,
          height
        } = this.$refs.table.$el.getBoundingClientRect();
        const margin = 100;

        if (top * -1 + wHeight >= height - margin && this.isBusy == false) {
          this.pagination.page = this.pagination.page + 1
          const { pagination, filters } = this;
          this.getUserPermissions({ pagination, filters})
        }
      }
    },

    onLoadMore: function() {
      if (!this.isBusy && this.hasMorePages) {
        this.pagination.page = parseInt(this.usersPagination.currentPage) + 1;
        this.fetch();
      }
    },

    onSearchUsers: function(value) {
      if (value) { this.filters['name'] = value }
      else { delete this.filters['name'] }

      this.filtering = true;
      this.pagination.page = 1;

      this.$router.push({ query: this.filters }).catch(err => {});
      this.fetch();
    },

    onClearSearch: function() {
      this.onSearchUsers();
    },

    ...mapActions({
      getUserPermissions: 'userPermissions/getUserPermissions',
      updateUserPermissions: 'userPermissions/updateUserPermissions'
    })
  },
  
  components: {
    UserPermissionsTable,
    Search
  }
}
</script>

<style lang="scss">
  @import "~@/styles/components/loader";
  @import "~@/styles/components/coding-user-permissions/list";

  .header {
    #form-search-projects {
      width: 350px;
    }
  }
</style>